import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { N800 } from "@atlaskit/theme/colors";

import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { useSiteActivationContext } from "../../hooks";

export const HelperText = () => {
    const { formatMessage } = useIntl();

    const { isWorkspaceProduct } = useSiteActivationContext();

    const text = isWorkspaceProduct
        ? formatMessage({
              id: "siteActivation.nameSite.inputWorkspaceNameHelperText",
              defaultMessage:
                  "This workspace name is just a suggestion. Feel free to change to something your team will recognize."
          })
        : formatMessage({
              id: "siteActivation.nameSite.inputSiteNameHelperText",
              defaultMessage:
                  "This site name is just a suggestion. Feel free to change to something your team will recognize."
          });

    const a11y30695 = checkFeatureFlagGate(
        featureFlags.a11y30695OnboardingInstruction
    );

    return (
        <p id={a11y30695 ? "site-name-helper" : undefined} css={helperTextCss}>
            {text}
        </p>
    );
};

const helperTextCss = css({
    color: N800,
    fontSize: "0.75rem",
    lineHeight: 1.5,
    margin: "0.5rem 0 0"
});
